import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Step from '../shared/Step';
import GearItem from './GearItem';
import { addProductToCart, removeProductFromCart } from '../../reducers/cart';
import { selectGearOption, deselectGearOption } from '../../reducers/form';
//import API from '../../utils/api';
import GTMService, { TYPES } from '../../utils/gtm';

//const api = new API();
const gtm = new GTMService();

const Gears = ({
  isVisible,
  title,
  gender,
  age,
  selectedGearOptions,
  selectedCampOptions,
  selectGearOption,
  deselectGearOption,
  addProductToCart,
  removeProductFromCart,
}) => {
  const [gears, setGears] = useState([]);

  const includedAdd = useCallback(async (item) => {
    var selectedVariant = item.variants[0].id;
    console.log('INCLUDED selectedVariant', selectedVariant);
    const res = await addProductToCart({
      type: 'shopify_gear',
      product: item,
      quantity: 1,
      attributes: [
        {
          bundle: false,
          selectedVariant: selectedVariant,
        },
      ],
    });
    if (res) {
      selectGearOption(item.id, {
        participantProductId: res.participant_product_id,
        name: item.name,
        product: item,
      });
      gtm.trackAddToCart(item, 'gear');
      gtm.trackChange(TYPES.OR_CAMPER_GEAR);
    }
  }, [addProductToCart, selectGearOption]);

  useEffect(() => {
    if(window.gear_products){
      console.log('Gender:', gender);
      var camp_product_cross_sell = false;
      var cart_products = window.newcart.cart.participants[0].products;
      for (let cart_product of cart_products) {
        if(cart_product.type === "camp") {
          if (typeof cart_product.product.cross_sell !== 'undefined') {
            camp_product_cross_sell = cart_product.product.cross_sell;
            camp_product_cross_sell.boarding = cart_product.product.boarding.toLowerCase();
            camp_product_cross_sell = Object.values(camp_product_cross_sell);
          }
        }
      }
      console.log('Camp_product_cross_sell:', camp_product_cross_sell);
      var gear_products = [];
      for (let gear_product of window.gear_products.products) {
        var show_product = false;
        var show_product_step = 0;
        var tags = `${gear_product.tags}`;
        var taglists = tags.split(', ');
        if(camp_product_cross_sell){
          if (typeof gear_product.cross_sell_tags !== 'undefined') {
            console.log('cross_sell_tags:', gear_product.cross_sell_tags);
            if(gear_product.cross_sell_tags.length) {
              for (let product_cross_sell of camp_product_cross_sell) {
                if(gear_product.cross_sell_tags.includes(product_cross_sell) === false) {
                  show_product = false;
                  show_product_step = 5;
                }
              }
            } else {
              show_product = false;
              show_product_step = 6;
            }
          }
        }
        if(taglists.includes('crosssell-always-display') === true) {
          show_product = true;
          show_product_step = 6;
        }
        // Gender Apply last
        var show_product_gender = false;
        var tagfound = false;
        for (let taglist of taglists) {
          if(gender === 'Female' && taglist === 'women'){
            show_product_gender = true;
            show_product_step = 1;
          } else if(gender === 'Male' && taglist === 'men'){
            show_product_gender = true;
            show_product_step = 2;
          }
          if(taglist === 'women' || taglist === 'men'){
            tagfound = true;
          }
        }
        if(tagfound === false){
          show_product_gender = true;
          show_product_step = 3;
        }
        if(!gender) {
          show_product_gender = true;
          show_product_step = 4;
        }
        console.log('show_product:', tags, show_product, show_product_gender, show_product_step);
        if(show_product && show_product_gender){
          gear_products.push(gear_product);
        }
      }
      window.gear_products_active = gear_products;

      for (let gear_product of gear_products) {
        if(parseFloat(gear_product.price) === 0) {
          console.log('INCLUDED', gear_product);
          includedAdd(gear_product);
        }
      }
      setGears(gear_products);
    }
  }, [age, gender, includedAdd]);

  const handleAdd = async (item, selectedVariant, selectedVariant2, selectedVariant3, selectedQuantity) => {
    console.log('Add to cart item:', item);
    console.log('Add to cart:', selectedVariant, selectedVariant2, selectedVariant3, selectedQuantity);
    var foundVariant = 0;
    if(selectedVariant2) {
      selectedVariant = selectedVariant2;
      foundVariant = 1;
    }
    if(selectedVariant3) {
      selectedVariant = selectedVariant3;
      foundVariant = 2;
    }
    console.log('foundVariant added:',foundVariant);
    console.log('selectedVariant added:',selectedVariant);
    const res = await addProductToCart({
      type: 'shopify_gear',
      product: item,
      quantity: selectedQuantity,
      attributes: [
        {
          bundle: false,
          selectedVariant: selectedVariant,
        },
      ],
    });

    if (res) {
      selectGearOption(item.id, {
        participantProductId: res.participant_product_id,
        name: item.name,
        product: item,
      });
      gtm.trackAddToCart(item, 'gear');
      gtm.trackChange(TYPES.OR_CAMPER_GEAR);
    }
  };

  const handleRemove = async (item) => {
    await removeProductFromCart(
      selectedGearOptions[item.id].participantProductId
    );
    deselectGearOption(item.id);
  };

  console.log('GearsCheck',window);
  console.log('GearsCheck',isVisible,gears);

  if (!isVisible) {
    return null;
  }

  if (gears.length === 0) {
    return null;
  }

  return (
    <Step title="+">
      <Step.Sub title={title}>
        <div className="extras">
          <div className="extras__list">
            {gears.map((item, index) => {
              var isIncluded = false;
              if(parseFloat(item.price) === 0) {
                isIncluded = true;
              }
              return (
                <GearItem
                  key={`${item.name}-${index}`}
                  item={item}
                  isSelected={!!selectedGearOptions[item.id]}
                  isIncluded={isIncluded}
                  onAdd={(selectedVariant, selectedVariant2, selectedVariant3, selectedQuantity) => handleAdd(item, selectedVariant, selectedVariant2, selectedVariant3, selectedQuantity)}
                  onRemove={() => handleRemove(item)}
                  selectedVariant={`0`}
                  selectedVariant2={`0`}
                  selectedVariant3={`0`}
                  defaultQuantity={`1`}
                  defaultStep={`1`}
                />
              );
            })}
          </div>
        </div>
      </Step.Sub>
    </Step>
  );
};

const mapStateToProps = (state) => ({
  gender: state.form.camper.gender,
  age: state.form.camper.age,
  selectedGearOptions: state.form.selectedGearOptions,
  selectedCampOptions: state.form.selectedCampOptions,
});

const mapDispatchToProps = (dispatch) => ({
  addProductToCart: (product) => dispatch(addProductToCart(product)),
  removeProductFromCart: (id) => dispatch(removeProductFromCart(id)),
  selectGearOption: (key, value) => dispatch(selectGearOption(key, value)),
  deselectGearOption: (key) => dispatch(deselectGearOption(key)),
});

Gears.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  age: PropTypes.string,
  gender: PropTypes.string,
  selectedGearOptions: PropTypes.object.isRequired,
  addProductToCart: PropTypes.func.isRequired,
  removeProductFromCart: PropTypes.func.isRequired,
  selectGearOption: PropTypes.func.isRequired,
  deselectGearOption: PropTypes.func.isRequired,
};

Gears.displayName = 'Gears';

export default connect(mapStateToProps, mapDispatchToProps)(Gears);
